// @internal
import styled, { css } from 'styled-components';
import { StyledSideNavProps } from '../../styles';
import { sidenavTokens } from '../../../../tokens/components/SideNav/tokens';

type StyledSideNavIconBadgeProps = Pick<StyledSideNavProps, 'isClosed'> & {
  isBadged?: boolean;
};

export const StyledSideNavIconBadge = styled.span<StyledSideNavIconBadgeProps>`
  background-color: ${sidenavTokens.IconBadgeBackgroundColorBaseDefault};
  border-radius: ${sidenavTokens.IconBadgeBorderRadiusBaseDefault};
  height: ${sidenavTokens.IconBadgeDimensionBaseDefault};
  position: absolute;
  right: ${sidenavTokens.IconBadgePositionRightBaseDefault};
  top: ${sidenavTokens.IconBadgePositionTopBaseDefault};
  width: ${sidenavTokens.IconBadgeDimensionBaseDefault};
  transform: ${({ isBadged }) => (isBadged ? 'scale(1)' : 'scale(0)')};
  transition: ${`transform ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault}`};
  transition-delay: ${({ isClosed }) => (isClosed ? sidenavTokens.IconBadgeTransitionDelayBaseDefault : '0s')};
`;

type StyledSideNavIconProps = Pick<StyledSideNavProps, 'isClosed' | 'isActive'>;

export const StyledSideNavIcon = styled.span<StyledSideNavIconProps>`
  border-radius: ${sidenavTokens.IconBorderRadiusBaseDefault};
  position: relative;
  transition: ${`width ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault},
          margin-right ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault},
          `};
  text-align: center;
  display: inline-flex;
  margin-right: ${sidenavTokens.IconMarginRightBaseOpen};
  padding: 2px;

  ${({ isClosed }) =>
    isClosed &&
    css`
      margin-right: 0;
    `}

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${sidenavTokens.IconBackgroundColorActiveDefault};
    `}
`;
